const initAccordions = () => {
  const $accordions = jQuery('.js-accordion');
  $accordions.each(function () {
    const $accordion = jQuery(this);
    const $content = $accordion.parent().find('.js-accordion-main');

    $accordion.on('click', function () {
      $accordion.toggleClass('is-open');
      $accordion.parent().toggleClass('is-open');
      $content.stop().slideToggle(300);
    });
  });
}

/**
 * Initialize WooCommerce filter accordion
 * Makes all WooCommerce filter widgets collapsible by clicking on headings
 * Supports: attribute, price, rating, status, and other filter blocks
 */
const initWooCommerceFilterAccordion = () => {
  // Select all WooCommerce product filter blocks
  const filterSelectors = [
    ".wp-block-woocommerce-product-filter-attribute",
    ".wp-block-woocommerce-product-filter-price",
    ".wp-block-woocommerce-product-filter-rating",
    ".wp-block-woocommerce-product-filter-status",
    "[class*='wp-block-woocommerce-product-filter-']"
  ];

  // Combine all filters into a single NodeList
  let allFilters = [];
  filterSelectors.forEach(selector => {
    const filters = document.querySelectorAll(selector);
    filters.forEach(filter => {
      if (!allFilters.includes(filter)) {
        allFilters.push(filter);
      }
    });
  });

  allFilters.forEach((filter) => {
    const heading = filter.querySelector(".wp-block-heading");
    if (heading) {
      heading.style.cursor = "pointer";

      heading.addEventListener("click", () => {
        // If this item is already open, close it
        if (filter.classList.contains("open")) {
          filter.classList.remove("open");
        } else {
          // Close all filters
          allFilters.forEach((f) => f.classList.remove("open"));
          // Open this one
          filter.classList.add("open");
        }
      });
    }
  });
}

export {initAccordions, initWooCommerceFilterAccordion}
